<template>
  <div>
    <p>
      <el-input v-model="type_name" size="small" placeholder="请输入内容" style="width:400px;margin-right:10px;" />
      <span style="display: inline-block; margin-right: 15px; color:#909399; fontSize:14px; fontWeight: bold;">是否选择部门</span>
      <el-switch
        v-model="is_department"
        :active-value="1"
        :inactive-value="0"
        :title="is_department==1?'是':'否'"
        active-color="#13ce66"
        active-text="是"
        inactive-color="#909399"
        inactive-text="否"
        style="margin-right:15px"
      />
      <el-button size="mini" type="success" icon="el-icon-plus" style="width:80px;" @click="addBtn">新增</el-button>
    </p>
    <el-table ref="multipleTable" :data="tableData" :show-header="true" tooltip-effect="dark" style="width: 100%">
      <el-table-column min-width="250px" label="会议类型">
        <template slot-scope="scope">
          <template v-if="scope.row.edit">
            <el-input v-model="scope.row.type_name" class="edit-input" size="small" />
            <el-button
              class="cancel-btn"
              size="mini"
              icon="el-icon-refresh"
              type="warning"
              style="margin-top:3px"
              @click="cancelEdit(scope.row)">取消</el-button>
          </template>
          <span v-else>{{ scope.row.originalTitle }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="is_department" label="是否选择部门" width="150">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.is_department"
            :active-value="1"
            :inactive-value="0"
            :title="scope.row.is_department==1?'是':'否'"
            :disabled="!scope.row.edit"
            active-color="#13ce66"
            inactive-color="#909399"/>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="创建人" />
      <el-table-column prop="add_time" label="创建时间" />

      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <!-- <el-button type="text" size="small" @click="handleClick(scope.row)">编辑</el-button> -->
          <el-button
            v-if="scope.row.edit"
            type="primary"
            size="mini"
            @click="confirmEdit(scope.row)">保存</el-button>
          <el-button v-else type="success" size="mini" @click="editTab(scope.row)">编辑
          </el-button>
        </template>
      </el-table-column>
    </el-table>

  </div>
</template>

<script>
import { searchType, addType, editType } from '@/api/meetingType'
export default {
  data() {
    return {
      type_name: '',
      is_department: 0,
      tableData: [],
      multipleSelection: []
    }
  },
  created() {
    this.getTypeList()
  },
  methods: {
    getTypeList() {
      searchType().then(response3 => {
        if (response3.code === 'success') {
          if (response3.data.types) {
            const responseData = response3.data.types

            for (const i in responseData) {
              this.$set(responseData[i], 'edit', false) // https://vuejs.org/v2/guide/reactivity.html
              responseData[i].originalTitle = responseData[i].type_name
            }

            this.tableData = responseData
          } else {
            this.tableData = []
          }
        } else {
          this.errMsg()
        }
      }).catch()
    },

    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 增加会议类型
    addBtn() {
      if (this.type_name !== '') {
        let open = '不开启'
        if (this.is_department === 1) {
          open = '开启'
        }
        const message = `新增会议类型 ${this.type_name}，${open} 选择部门 ？`
        this.$confirm(message, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          const params = {
            type_name: this.type_name,
            is_department: this.is_department
          }
          addType(params).then(response2 => {
            if (response2.code === 'success') {
              this.successMsg()
              this.getTypeList()
            } else {
              this.errMsg()
            }
            this.type_name = ''
            this.is_department = 0
          }).catch()
        }).catch(() => {
          this.$message.info('已取消！')
        })
      } else {
        this.$message.warning('请先输入内容后点击新增')
      }
    },
    editTab(row) {
      row.edit = !row.edit
      row.originalType = row.is_department
    },
    // 编辑
    cancelEdit(row) {
      row.type_name = row.originalTitle
      row.is_department = row.originalType
      row.edit = false
      this.$message({
        message: '已取消修改',
        type: 'warning'
      })
    },
    confirmEdit(row) {
      const params = {
        type_name: row.type_name,
        is_department: row.is_department
      }
      editType(row.id, params).then(res => {
        if (res.code === 'success') {
          row.edit = false
          row.originalTitle = row.type_name
          // row.is_department = row.originalType;
          this.$message({
            message: '保存成功',
            type: 'success'
          })
        } else {
          row.edit = true
          row.type_name = row.originalTitle
          row.is_department = row.originalType
        }
      }).catch(err => { console.log(err) })
    },
    successMsg() {
      this.$message({
        message: '操作成功',
        type: 'success'
      })
    },
    errMsg() {
      this.$message({
        message: '操作失败',
        type: 'error'
      })
    }

  }
}
</script>

<style scoped>
  .edit-input {
    padding-right: 100px;
  }

  .cancel-btn {
    position: absolute;
    right: 15px;
    top: 10px;
  }
</style>
